import React from 'react';
import {
  Shield,
  PenTool,
  CheckCircle,
  Clock
} from 'lucide-react';
import DigitalSignature from '../DigitalSignature';
import SignatureDisplay from '../SignatureDisplay';

const SignatureSection = ({
  log,
  signatureRequirements,
  signatures,
  loadingSignatures,
  signingInProgress,
  showSignatureModal,
  setShowSignatureModal,
  onSignatureSubmit,
  user
}) => {
  if (!log || !log.id) return null;

  return (
    <div className="border-t border-gray-200 pt-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900 flex items-center">
          <Shield size={20} className="mr-2 text-cyan-600" />
          Digital Signatures
        </h3>
        {(() => {
          console.log('Current signatureRequirements state:', signatureRequirements);
          console.log('Can sign technician:', signatureRequirements?.user_permissions?.can_sign_technician);
          console.log('Can sign approval:', signatureRequirements?.user_permissions?.can_sign_approval);
          console.log('Can sign witness:', signatureRequirements?.user_permissions?.can_sign_witness);
          return (signatureRequirements?.user_permissions?.can_sign_technician || signatureRequirements?.user_permissions?.can_sign_approval || signatureRequirements?.user_permissions?.can_sign_witness) && (
            <button
              type="button"
              onClick={() => setShowSignatureModal(true)}
              disabled={signingInProgress}
              className="flex items-center px-4 py-2 bg-cyan-600 text-white rounded-lg hover:bg-cyan-700 transition-colors disabled:opacity-50"
            >
              <PenTool size={16} className="mr-2" />
              {signingInProgress ? 'Signing...' : 'Add Signature'}
            </button>
          );
        })()}
      </div>

      {/* Signature Requirements Status */}
      {signatureRequirements && (
        <div className="bg-gray-50 rounded-lg p-4 mb-4">
          <h4 className="text-sm font-medium text-gray-700 mb-2">Signature Status</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex items-center">
              {signatureRequirements.current_status.technician_signed ? (
                <CheckCircle size={16} className="text-green-600 mr-2" />
              ) : (
                <Clock size={16} className="text-orange-500 mr-2" />
              )}
              <span className="text-sm">
                Technician Signature: {signatureRequirements.current_status.technician_signed ? 'Complete' : 'Pending'}
              </span>
            </div>
            <div className="flex items-center">
              {signatureRequirements.current_status.approval_signed ? (
                <CheckCircle size={16} className="text-green-600 mr-2" />
              ) : (
                <Clock size={16} className="text-orange-500 mr-2" />
              )}
              <span className="text-sm">
                Approval Signature: {signatureRequirements.current_status.approval_signed ? 'Complete' : 'Pending'}
              </span>
            </div>
          </div>
          {signatureRequirements.requirements.requires_technician_signature && (
            <p className="text-xs text-gray-600 mt-2">
              Technician signature required for completion
            </p>
          )}
          {signatureRequirements.requirements.requires_approval_signature && (
            <p className="text-xs text-gray-600 mt-1">
              Management approval signature required
            </p>
          )}
        </div>
      )}

      {/* Existing Signatures Display */}
      {signatures.length > 0 && (
        <SignatureDisplay
          signatures={signatures}
          serviceLogId={log.id}
          loading={loadingSignatures}
        />
      )}

      {signatures.length === 0 && !loadingSignatures && (
        <div className="text-center py-8 text-gray-500">
          <PenTool size={32} className="mx-auto mb-2 opacity-50" />
          <p>No signatures yet</p>
        </div>
      )}

      {loadingSignatures && (
        <div className="flex items-center justify-center py-8">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-cyan-600 mr-2"></div>
          <span className="text-gray-600">Loading signatures...</span>
        </div>
      )}

      {/* Digital Signature Modal */}
      {showSignatureModal && (
        <DigitalSignature
          onSignatureCapture={onSignatureSubmit}
          onCancel={() => setShowSignatureModal(false)}
          signerName={user?.name ? `${user.name} ${user.surname}` : ''}
          isOpen={showSignatureModal}
          disabled={signingInProgress}
        />
      )}
    </div>
  );
};

export default SignatureSection;
